import { store } from "../../store";
import createRPCQuery from "../../../utils/createRPCQuery.util";
import { getPRPC } from "../../../hooks/usePRPC";
import { defaultLanguage } from "../../../assets/languages/langs";

// TODO: rewrite. is not correct
export default async function getReveal(point, params?: any) {
	const prpcow = getPRPC();

	if (!prpcow) throw Error(`prpcow didn't initialize`);

	const fn = async () =>
		createRPCQuery(
			() =>
				prpcow?.theirsModel.map.reveal(point, {
					...params,
					radius: store.getState().settings.map.revealRadiusMeters,
					lang: store.getState().session.language || defaultLanguage,
				}),
			{
				silent: false,
				error: true,
			},
		);

	let res = await fn();

	if (res?.error && res?.data?.status === 500) {
		res = await fn();
	}

	if (res?.error && res?.data?.status === 500) {
		res = await fn();
	}

	if (res?.error && res?.data?.status === 500) {
		res = await fn();
	}

	if (res?.error && res?.data?.status === 500) {
		res = await fn();
	}

	if (res?.error && res?.data?.status === 500) {
		res = await fn();
	}

	return res;
}
